// extracted by mini-css-extract-plugin
module.exports = {"navItemLink":"_13UhQ","navItem":"_1dXLd","dropdownIcon":"_3qNgO","open":"_3MIOK"};